export enum HttpRequestHeaderType {
  ApplicationJson = 'application/json',
  MultipartFormData = 'multipart/form-data',
}

export enum HttpRequestMethodType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}
